/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type CloseSmallIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let CloseSmallIcon: NessieFunctionComponent<CloseSmallIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.433 6.433a1.48 1.48 0 000 2.093L9.908 12l-3.475 3.474a1.48 1.48 0 002.093 2.093L12 14.092l3.474 3.475a1.48 1.48 0 002.093-2.093L14.092 12l3.475-3.474a1.48 1.48 0 00-2.093-2.093L12 9.908 8.526 6.433a1.48 1.48 0 00-2.093 0z"
          />
          <mask maskUnits="userSpaceOnUse" x={6} y={6} width={12} height={12}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.433 6.433a1.48 1.48 0 000 2.093L9.908 12l-3.475 3.474a1.48 1.48 0 002.093 2.093L12 14.092l3.474 3.475a1.48 1.48 0 002.093-2.093L14.092 12l3.475-3.474a1.48 1.48 0 00-2.093-2.093L12 9.908 8.526 6.433a1.48 1.48 0 00-2.093 0z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
CloseSmallIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  CloseSmallIcon = nessiePropCheckerWrapper(CloseSmallIcon);
}

export default CloseSmallIcon;
